/**
 * Carrega /mic-recorder-to-mp3.js sob demanda (script global).
 * A lib precisa rodar como script clássico: bundlar com Vite/ESM quebra
 * com "Lame is not defined". O script só é baixado na primeira gravação.
 */
let scriptPromise = null;
let recorder = null;

function loadScript() {
  if (typeof window !== 'undefined' && window.MicRecorder) {
    return Promise.resolve();
  }
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = '/mic-recorder-to-mp3.js';
      script.onload = () => resolve();
      script.onerror = () => {
        scriptPromise = null;
        reject(new Error('Falha ao carregar /mic-recorder-to-mp3.js'));
      };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

export async function getMp3Recorder() {
  await loadScript();
  if (!recorder) {
    recorder = new window.MicRecorder({ bitRate: 128 });
  }
  return recorder;
}

/**
 * Pré-carrega o script em idle (pós-login), fora do caminho crítico do primeiro
 * paint. Evita o custo de download+parse na primeira gravação.
 */
export function preloadMicRecorder() {
  const run = () => loadScript().catch(() => {});
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout: 5000 });
  } else {
    setTimeout(run, 3000);
  }
}
